import { createSelector } from 'reselect';
import _flatten from 'lodash/flatten';
import _has from 'lodash/has';
import _omit from 'lodash/omit';

import {
  getHasFlowEnabled,
  getHasFlowV2Enabled,
} from 'store/services/project/selectors';

export const getSidebarIsOpen = ({ settings }) => settings.isOpen;

export const getMenuItemsFromStore = ({ settings }) => settings.menuItems;

export const getMenuItems = createSelector(
  getMenuItemsFromStore,
  getHasFlowEnabled,
  getHasFlowV2Enabled,
  (items, hasFlowEnabled, hasFlowV2Enabled) =>
    items.filter(({ apptitle }) => {
      if (
        (apptitle === 'flow' && !hasFlowEnabled) ||
        (apptitle === 'new-flow' && !hasFlowV2Enabled)
      ) {
        return false;
      }

      return true;
    }),
);

export const getFlattenedMenuItems = createSelector(
  getMenuItems,
  items =>
    items.reduce((acc, item) => {
      if (_has(item, 'groups')) {
        return [
          ...acc,
          _omit(item, 'groups'),
          ..._flatten(item.groups.map(({ children }) => children)),
        ];
      }

      return [...acc, item];
    }, []),
);

export const getCurrentMenuItem = createSelector(
  getFlattenedMenuItems,
  items => items.find(item => window.location.href.includes(item.apptitle)),
);
